<template>
  <div class="card shadow-sm border-0 rounded-custom mt-4">
    <div class="card-body p-4 p-lg-5">
      <h2 class="text-violet text-uppercase mb-3">
        {{ isEditMode ? $t("Record management") : $t("Registration summary") }}
      </h2>
      <p class="text-muted mb-4">
        {{ isEditMode
          ? $t("From here you can manage the record photo, replace it or remove it.")
          : $t("You can attach the photo from this computer or from your phone via QR code.") }}
      </p>

      <dl class="row mb-0">
        <dt class="col-sm-4">{{ $t("Milled elements") }}</dt>
        <dd class="col-sm-8">{{ log.milled_elements_count }}</dd>

        <dt class="col-sm-4">{{ $t("Material") }}</dt>
        <dd class="col-sm-8">{{ log.material_name || $t("Not specified") }}</dd>

        <dt class="col-sm-4">{{ $t("Machine") }}</dt>
        <dd class="col-sm-8">{{ log.machine_name || $t("Not specified") }}</dd>

        <dt class="col-sm-4">{{ $t("Notes") }}</dt>
        <dd class="col-sm-8">{{ log.notes || "-" }}</dd>

        <dt class="col-sm-4">{{ $t("Photo") }}</dt>
        <dd class="col-sm-8">
          <span v-if="log.photo_media_uuid">{{ $t("Uploaded") }}</span>
          <span v-else>{{ $t("Not uploaded yet") }}</span>
        </dd>
      </dl>

      <div v-if="log.photo_url" class="mt-4">
        <img
          :src="log.photo_url"
          :alt="$t('CAM attached photo')"
          class="w-100 rounded border"
          style="max-height: 320px; object-fit: contain"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CamProductionRecordSummary",
  props: {
    log: {
      type: Object,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
